module.exports = __webpack_public_path__ + "img/th.32e0ced1.png";